var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("main", { staticClass: "page-live-reservation-bpc" }, [
      _c("img", {
        attrs: {
          src:
            "https://summer-storage.oss-cn-shanghai.aliyuncs.com/BPC2026/live/bpc-cover.jpg",
          alt: "BPC 直播预约海报"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }